/* tslint:disable */
/* eslint-disable */
/**
 * DEX API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import {
  AccountInfoResponse,
  AccountInfoResponseFromJSON,
  AccountInfoResponseToJSON,
  AffiliateDistributionRequest,
  AffiliateDistributionRequestFromJSON,
  AffiliateDistributionRequestToJSON,
  AffiliateResponse,
  AffiliateResponseFromJSON,
  AffiliateResponseToJSON,
  LinkCadabraWalletRequest,
  LinkCadabraWalletRequestFromJSON,
  LinkCadabraWalletRequestToJSON,
  ReferralInfo,
  ReferralInfoFromJSON,
  ReferralInfoToJSON,
  UserFarmingLevelResponse,
  UserFarmingLevelResponseFromJSON,
  UserFarmingLevelResponseToJSON,
} from '../models'

export interface LinkCadabraWalletOperationRequest {
  linkCadabraWalletRequest?: LinkCadabraWalletRequest
}

export interface SetAffiliateDistributionRequest {
  affiliateDistributionRequest?: AffiliateDistributionRequest
}

/**
 *
 */
export class AccountApi extends runtime.BaseAPI {
  /**
   */
  async getAccountInfoRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<AccountInfoResponse>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/api/private/account/info`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response, (jsonValue) => AccountInfoResponseFromJSON(jsonValue))
  }

  /**
   */
  async getAccountInfo(initOverrides?: RequestInit): Promise<AccountInfoResponse> {
    const response = await this.getAccountInfoRaw(initOverrides)
    return await response.value()
  }

  /**
   */
  async getAffiliateInfoRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<AffiliateResponse>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/api/private/affiliate`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response, (jsonValue) => AffiliateResponseFromJSON(jsonValue))
  }

  /**
   */
  async getAffiliateInfo(initOverrides?: RequestInit): Promise<AffiliateResponse> {
    const response = await this.getAffiliateInfoRaw(initOverrides)
    return await response.value()
  }

  /**
   */
  async getDirectReferralsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<ReferralInfo>>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/api/private/affiliate/direct-referrals`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ReferralInfoFromJSON))
  }

  /**
   */
  async getDirectReferrals(initOverrides?: RequestInit): Promise<Array<ReferralInfo>> {
    const response = await this.getDirectReferralsRaw(initOverrides)
    return await response.value()
  }

  /**
   */
  async getFarmingLevelRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<UserFarmingLevelResponse>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/api/private/referral-program/account/farming-level`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response, (jsonValue) => UserFarmingLevelResponseFromJSON(jsonValue))
  }

  /**
   */
  async getFarmingLevel(initOverrides?: RequestInit): Promise<UserFarmingLevelResponse> {
    const response = await this.getFarmingLevelRaw(initOverrides)
    return await response.value()
  }

  /**
   */
  async linkCadabraWalletRaw(
    requestParameters: LinkCadabraWalletOperationRequest,
    initOverrides?: RequestInit,
  ): Promise<runtime.ApiResponse<void>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    const response = await this.request(
      {
        path: `/api/private/cadabra-linked-nmx-user`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: LinkCadabraWalletRequestToJSON(requestParameters.linkCadabraWalletRequest),
      },
      initOverrides,
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   */
  async linkCadabraWallet(
    requestParameters: LinkCadabraWalletOperationRequest = {},
    initOverrides?: RequestInit,
  ): Promise<void> {
    await this.linkCadabraWalletRaw(requestParameters, initOverrides)
  }

  /**
   */
  async setAffiliateDistributionRaw(
    requestParameters: SetAffiliateDistributionRequest,
    initOverrides?: RequestInit,
  ): Promise<runtime.ApiResponse<void>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    const response = await this.request(
      {
        path: `/api/private/affiliate/distribution`,
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: AffiliateDistributionRequestToJSON(requestParameters.affiliateDistributionRequest),
      },
      initOverrides,
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   */
  async setAffiliateDistribution(
    requestParameters: SetAffiliateDistributionRequest = {},
    initOverrides?: RequestInit,
  ): Promise<void> {
    await this.setAffiliateDistributionRaw(requestParameters, initOverrides)
  }
}
